import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_settings.svg';
import Icon, { IconProps } from './icon';

const IconSettings = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconSettings;
